import React, { useState } from "react";
import Modal from "react-modal";

import '../App.css';

const Tips = (props) => {
  const [tip_1_is_open, tip_1_is_open_update] = useState(false);

  let tam1, tam2, vida1, vida2, intel1, intel2, depor2, clima2;

  if (props.items.size === 1) {
    tam1 = "/img/tam_1_1.png";
    tam2 = "/img/tam_2_1.png";
  } else if (props.items.size === 2) {
    tam1 = "/img/tam_1_2.png";
    tam2 = "/img/tam_2_2.png";
  } else if (props.items.size === 3) {
    tam1 = "/img/tam_1_3.png";
    tam2 = "/img/tam_2_3.png";
  } else {
    tam1 = "/img/tam_1_4.png";
    tam2 = "/img/tam_2_4.png";
  }

  if (props.items.vida === 1) {
    vida1 = "/img/vida_1_1.png";
    vida2 = "/img/vida_2_1.png";
  } else if (props.items.vida === 2) {
    vida1 = "/img/vida_1_2.png";
    vida2 = "/img/vida_2_2.png";
  } else if (props.items.vida === 3) {
    vida1 = "/img/vida_1_3.png";
    vida2 = "/img/vida_2_3.png";
  } else {
    vida1 = "/img/vida_1_4.png";
    vida2 = "/img/vida_2_4.png";
  }

  if (props.items.intel === 1) {
    intel1 = "/img/intel_1_1.png";
    intel2 = "/img/intel_2_1.png";
  } else if (props.items.intel === 2) {
    intel1 = "/img/intel_1_1.png";
    intel2 = "/img/intel_2_2.png";
  } else if (props.items.intel === 3) {
    intel1 = "/img/intel_1_2.png";
    intel2 = "/img/intel_2_3.png";
  } else if (props.items.intel === 4) {
    intel1 = "/img/intel_1_3.png";
    intel2 = "/img/intel_2_4.png";
  } else if (props.items.intel === 5) {
    intel1 = "/img/intel_1_4.png";
    intel2 = "/img/intel_2_5.png";
  } else {
    intel1 = "/img/intel_1_4.png";
    intel2 = "/img/intel_2_6.png";
  }

  if (props.items.deporte === 1) {
    depor2 = "/img/depor_2_1.png";
  } else if (props.items.deporte === 2) {
    depor2 = "/img/depor_2_2.png";
  } else if (props.items.deporte === 3) {
    depor2 = "/img/depor_2_3.png";
  } else {
    depor2 = "/img/depor_2_4.png";
  }

  if (props.items.clima === 1) {
    clima2 = "/img/clima_2_1.png";
  } else if (props.items.clima === 2) {
    clima2 = "/img/clima_2_2.png";
  } else if (props.items.clima === 3) {
    clima2 = "/img/clima_2_3.png";
  } else {
    clima2 = "/img/clima_2_4.png";
  }

  return (
    <div className="tips_css">
      {/* agregar foto en css y aca ---------------------------------------------------------- */}
      <div className="tip_css">
        <Modal
          isOpen={tip_1_is_open}
          onRequestClose={() => tip_1_is_open_update(false)}
          style={{
            content: {
              padding: "0",
              margin: "auto",
              top: "10px",
              right: "10px",
              bottom: "10px",
              left: "10px",
              borderRadius: "15px",
              maxWidth: "500px",
            },
          }}
        >
          <img
            className="close_button"
            src="/img/close.png"
            alt=""
            onClick={() => tip_1_is_open_update(false)}
          ></img>
          <img className="foto_modal " src={props.items.n} alt=""></img>
          <h4 className="modal_h4">{props.items.nombre1}</h4>
          <h5 className="modal_h5">{props.items.nombre2}</h5>
          <div className="div_caracteristicas">
            <img src={tam2} alt=""></img>
            <img src={vida2} alt=""></img>
            <img src={depor2} alt=""></img>
            <img src={clima2} alt=""></img>
            <img className="intel_img" src={intel2} alt=""></img>
          </div>

          <div className="div_description">
            <p className="titulo">Origen: {props.items.pais_origen}</p>
            <p className="desc">{props.items.origen}</p>
          </div>

          <div className="div_description">
            <p className="titulo">Características</p>
            <p className="desc">{props.items.caracteristica}</p>
          </div>

          <div className="div_description">
            <p className="titulo">Ideal para</p>
            <p className="desc">{props.items.ideal}</p>
          </div>

          <div className="div_description">
            <p className="titulo">Recomendación</p>
            <p className="desc">{props.items.recomendacion}</p>
          </div>

          <div className="div_description">
            <p className="titulo">Dato Freak</p>
            <p className="desc">{props.items.dato}</p>
          </div>

          <div className="top">
            <img
              src="/img/top_ladrador.png"
              alt=""
              style={{ display: props.items.ladrido }}
            ></img>
            <img
              src="/img/top_child.png"
              alt=""
              style={{ display: props.items.child }}
            ></img>
            <img
              src="/img/top_salud.png"
              alt=""
              style={{ display: props.items.salud }}
            ></img>
            <img
              src="/img/top_inteligente.png"
              alt=""
              style={{ display: props.items.intel2 }}
            ></img>
            <img
              src="/img/top_depa.png"
              alt=""
              style={{ display: props.items.depa }}
            ></img>
            <img
              src="/img/top_antiguo.png"
              alt=""
              style={{ display: props.items.antig }}
            ></img>
          </div>

          <p className="animalexperto">
            Revisa la ficha de AnimalExperto{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={props.items.link}
            >
              aquí.
            </a>
          </p>

          <img
            src="/img/logo_footer2.png"
            alt=""
            style={{ width: "65px", marginTop: "5px", marginBottom: "20px" }}
          ></img>
        </Modal>

        <div onClick={() => tip_1_is_open_update(true)}>
          <img className="img_css" src={props.items.n} alt=""></img>
          <h1>{props.items.nombre1}</h1>
          <div className="perfil">
            <img className="perfil_raza" src={tam1} alt=""></img>
            <img className="perfil_raza" src={vida1} alt=""></img>
            <img className="perfil_raza" src={intel1} alt=""></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tips;
